import { render, staticRenderFns } from "./DisplayBuilderOptions.vue?vue&type=template&id=88414734&scoped=true"
import script from "./DisplayBuilderOptions.vue?vue&type=script&lang=js"
export * from "./DisplayBuilderOptions.vue?vue&type=script&lang=js"
import style0 from "./DisplayBuilderOptions.vue?vue&type=style&index=0&id=88414734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88414734",
  null
  
)

export default component.exports